import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '../../../assets/icons/actions/CloseIcon';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import CursorLeftIcon from '../../../assets/icons/CursorLeftIcon';
import classnames from 'classnames';

type Props = {
  show: boolean;
  onClose: () => void;
  className?: string;
};

const AllergensTip = ({ show, onClose, className }: Props) => {
  const { t } = useTranslation(null, { keyPrefix: 'Components:Menu:Allergens:AllergensTip' });

  const [visible, setVisible] = useState(show);

  const shouldReduceMotion = useReducedMotion();

  const _onClose = (e) => {
    e.stopPropagation();
    setVisible(false);
    onClose();
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: shouldReduceMotion ? 0 : 20, translateY: 100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: shouldReduceMotion ? 0 : 20, translateY: 100 }}
          transition={{ duration: shouldReduceMotion ? 0 : 0.3 }}
          className={classnames('absolute px-sm lg:bottom-0 -bottom-xl w-full z-[5]', className)}
        >
          <div className="p-md bg-brand-primary text-white rounded-lg dark:border dark:bg-black">
            <div className="flex items-center justify-between w-full">
              <h6 className="flex gap-2xs items-center">
                <CursorLeftIcon className="animate-bounce" />
                {t('title')}
              </h6>
              <button onClick={_onClose}>
                <CloseIcon />
              </button>
            </div>
            <p className="text-sm mt-sm">{t('description')}</p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default AllergensTip;
